import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';

/**
 * Section 8 — Personal & Family Care
 */
export default function StepPersonalFamilyCare({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const fields = [
    { key: 'groceries_household', label: 'Groceries & Household Supplies' },
    { key: 'restaurants_dining', label: 'Restaurants & Dining' },
    {
      key: 'gifts',
      label: 'Gifts',
      hint: 'Holidays, birthdays, planned cash gifts, etc.',
    },
    { key: 'clothing_shoes', label: 'Clothing & Shoes' },
    { key: 'hair_skin_nails', label: 'Hair, Skin & Nail Care' },
    { key: 'pocket_money_cash', label: 'Pocket Money / Cash' },
    { key: 'technology_computers_devices', label: 'Technology, Computers & Mobile Devices' },
    {
      key: 'dues_memberships',
      label: 'Dues & Memberships',
      hint: 'Gym, country/golf clubs, community centers, subscription boxes, etc.',
    },
    { key: 'other_misc', label: 'Other Miscellaneous Expenses' },
  ];

  const total = fields.reduce(
    (sum, f) => sum + (Number(data[f.key]) || 0),
    0
  );

  return (
    <div>
      <SectionHeader
        number={8}
        title="Personal & Family Care"
        tip="A great starting point is a year-end bank or credit card statement —
          many banks automatically categorise your spending."
      />

      <div className="cashflow-field-grid">
        {fields.map(({ key, label, hint }) => (
          <CurrencyInput
            key={key}
            id={key}
            label={label}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
            hint={hint}
          />
        ))}
      </div>

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">8: Total Personal & Family Care</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
